
<ng-container *ngIf="isSmallerScreenObs | async;else standardMode">

    <button *ngIf="['update'].includes(modeSubject | async)" mat-raised-button color="warn"  (click)="delete.emit()">
        <mat-icon>delete</mat-icon>
        {{'ss-crud.delete' | translate}} 
    </button>


    <button *ngIf="['update'].includes(modeSubject | async)" mat-raised-button   (click)="reset.emit()">
        <mat-icon>refresh</mat-icon>
        {{'ss-crud.reset' | translate}} 
    </button>
    
    <button *ngIf="['save','update'].includes(modeSubject | async)" mat-raised-button color="primary" (click)="save.emit()">
        <mat-icon>save</mat-icon>
        {{'ss-crud.save' | translate}} 
    </button>
    
    
</ng-container>

<ng-template #standardMode>
    
    <div class="flex-row flex--align-center gap-standard">
    
        <button *ngIf="['update'].includes(modeSubject | async)" mat-raised-button color="warn"  (click)="delete.emit()">
            <mat-icon>delete</mat-icon>
            {{'ss-crud.delete' | translate}} 
        </button>
    
    </div>
    
    <div class="flex-row flex--align-center gap-standard">
    
        <button *ngIf="['update'].includes(modeSubject | async)" mat-raised-button  (click)="reset.emit()">
            <mat-icon>refresh</mat-icon>
            {{'ss-crud.reset' | translate}} 
        </button>

        <button *ngIf="['save','update'].includes(modeSubject | async)" mat-raised-button color="primary" (click)="save.emit()">
            <mat-icon>save</mat-icon>
            {{'ss-crud.save' | translate}} 
        </button>
    
    

        
    </div>
</ng-template>
